import { ICommand, IResult } from "@ms/utilities-cross-window";
import { IEventDispatch } from "../../common/utilities/dispatch";
import { IEmbedContext } from "../contexts/embed";

const { LoadFailure } = window.Resources.Common;

/**
 * Utility function that contains the boiler plate code for sending a command to the host client and handling errors
 */
export function sendCommand<T extends ICommand>(
  embedContext: IEmbedContext,
  options: {
    command: T;
    event: {
      name: string;
      action: string;
    };
    eventDispatch: IEventDispatch;
  }
): Promise<IResult> {
  const { command, event, eventDispatch } = options;

  let result: Partial<PromiseSettledResult<void>>;

  if (embedContext.hostClient) {
    return embedContext.hostClient.ready
      .then(() => {
        return embedContext.hostClient!.sendCommand(command, { timeoutDelayMs: 120000 /* 2 minutes */ }).then((result: IResult) => {
          if (result.result === "success") {
            eventDispatch.dispatchEvent("telemetryAvailable", { ...event, status: "fulfilled" });
          } else {
            eventDispatch.dispatchEvent("telemetryAvailable", {
              ...event,
              status: "rejected",
              reason: {
                isCanceled: result.error?.code?.toLowerCase() === "canceled",
                error: result.error
              }
            });
          }
          return result;
        });
      })
      .catch((error: Error) => {
        eventDispatch.dispatchEvent("telemetryAvailable", { ...event, action: "exception", error });
        eventDispatch.dispatchEvent("showMessage", { messageType: "error", title: LoadFailure });
        return Promise.reject({
          result: "error",
          isExpected: false,
          error: {
            code: error.name,
            message: error.message
          }
        });
      });
  } else {
    const code = "HostClientMissing";
    eventDispatch.dispatchEvent("telemetryAvailable", { ...event, action: "exception", error: { code } });
    eventDispatch.dispatchEvent("showMessage", { messageType: "error", title: LoadFailure });
    return Promise.reject({
      result: "error",
      isExpected: false,
      error: {
        code,
        message: LoadFailure
      }
    });
  }
}
